import type { LinePointData } from "components/charting/types/Chart.types";
import Typography from "@mui/material/Typography";
import datetime from "config/datetime";
import OneRepMaxTooltipCardRow from "./components/OneRepMaxTooltipCardRow";
import OneRepMaxChartHelpers from "../helpers/OneRepMaxChartHelpers";
import type { OneRepMaxAggregationUnit } from "../helpers/OneRepMaxChartHelpers";
import useOneRepMaxChartWeightMetric from "../useOneRepMaxChartWeightMetric";
import Div from "components/primitives/Div";
import { styled } from "@mui/material";
import { useMemo } from "react";

const Root = styled(Div)(({ theme }) => ({
  backgroundColor: theme.palette.common.white,
  borderRadius: theme.spacing(0.5),
  display: "flex",
  flexDirection: "column",
  boxShadow: theme.shadows[4],
  padding: theme.spacing(1.5),
}));

interface OneRepMaxTooltipCardProps {
  points: LinePointData[];
  aggregationUnit: OneRepMaxAggregationUnit;
}

function OneRepMaxTooltipCard(props: OneRepMaxTooltipCardProps) {
  const { points, aggregationUnit } = props;
  const weightMetric = useOneRepMaxChartWeightMetric();

  const recordedDateFormatted = useMemo(() => {
    const recordedDate = datetime(OneRepMaxChartHelpers.getRecordedDate(points[0]));
    return recordedDate.format(OneRepMaxChartHelpers.getPeriodDateFormat(aggregationUnit));
  }, [aggregationUnit, points]);

  return (
    <Root>
      {aggregationUnit === "week" ? null : (
        <Typography variant="caption" color="grey.100">
          {recordedDateFormatted}
        </Typography>
      )}
      {points.map((point) => (
        <OneRepMaxTooltipCardRow key={`${point.entityId}-${point.variant}`} point={point} weightMetric={weightMetric} />
      ))}
    </Root>
  );
}

export default OneRepMaxTooltipCard;
